/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { OkResult } from '../models/ok-result';
@Injectable({
  providedIn: 'root',
})
class FilePortalService extends __BaseService {
  static readonly GetAllFileNamesForClientInBlobPath = '/fileportal/getallfilenamesforclientinblob/{year}/{month}/{clientId}';
  static readonly DownloadFileFromBlobPath = '/fileportal/downloadfilefromblob';
  static readonly CheckClientFileExistsPath = '/fileportal/checkClientFileExists';
  static readonly UploadClientFilePath = '/fileportal/uploadClientFile';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `FilePortalService.GetAllFileNamesForClientInBlobParams` containing the following parameters:
   *
   * - `year`:
   *
   * - `month`:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   */
  GetAllFileNamesForClientInBlobResponse(params: FilePortalService.GetAllFileNamesForClientInBlobParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/fileportal/getallfilenamesforclientinblob/${params.year}/${params.month}/${params.clientId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `FilePortalService.GetAllFileNamesForClientInBlobParams` containing the following parameters:
   *
   * - `year`:
   *
   * - `month`:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   */
  GetAllFileNamesForClientInBlob(params: FilePortalService.GetAllFileNamesForClientInBlobParams): __Observable<null> {
    return this.GetAllFileNamesForClientInBlobResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `FilePortalService.DownloadFileFromBlobParams` containing the following parameters:
   *
   * - `fullFilePath`:
   *
   * - `Authorization`: Bearer token
   */
  DownloadFileFromBlobResponse(params: FilePortalService.DownloadFileFromBlobParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.fullFilePath != null) __params = __params.set('fullFilePath', params.fullFilePath.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/fileportal/downloadfilefromblob`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `FilePortalService.DownloadFileFromBlobParams` containing the following parameters:
   *
   * - `fullFilePath`:
   *
   * - `Authorization`: Bearer token
   */
  DownloadFileFromBlob(params: FilePortalService.DownloadFileFromBlobParams): __Observable<null> {
    return this.DownloadFileFromBlobResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `FilePortalService.CheckClientFileExistsParams` containing the following parameters:
   *
   * - `year`:
   *
   * - `month`:
   *
   * - `fileName`:
   *
   * - `aviClientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  CheckClientFileExistsResponse(params: FilePortalService.CheckClientFileExistsParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.year != null) __params = __params.set('year', params.year.toString());
    if (params.month != null) __params = __params.set('month', params.month.toString());
    if (params.fileName != null) __params = __params.set('fileName', params.fileName.toString());
    if (params.aviClientId != null) __params = __params.set('aviClientId', params.aviClientId.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/fileportal/checkClientFileExists`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `FilePortalService.CheckClientFileExistsParams` containing the following parameters:
   *
   * - `year`:
   *
   * - `month`:
   *
   * - `fileName`:
   *
   * - `aviClientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  CheckClientFileExists(params: FilePortalService.CheckClientFileExistsParams): __Observable<boolean> {
    return this.CheckClientFileExistsResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `FilePortalService.UploadClientFileParams` containing the following parameters:
   *
   * - `year`:
   *
   * - `month`:
   *
   * - `isInvoice`:
   *
   * - `invoicedOn`:
   *
   * - `invoiceNumber`:
   *
   * - `invoiceDueDate`:
   *
   * - `invoiceAmount`:
   *
   * - `formFile`:
   *
   * - `fileType`:
   *
   * - `aviClientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  UploadClientFileResponse(params: FilePortalService.UploadClientFileParams): __Observable<__StrictHttpResponse<OkResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __headers.append('Content-Type', 'multipart/form-data');
    let __formData = new FormData();
    __body = __formData;
   if(params.year !== null && typeof params.year !== "undefined") { __formData.append('year', JSON.stringify(params.year));}
   if(params.month !== null && typeof params.month !== "undefined") { __formData.append('month', JSON.stringify(params.month));}
   if(params.isInvoice !== null && typeof params.isInvoice !== "undefined") { __formData.append('isInvoice', JSON.stringify(params.isInvoice));}
   if(params.invoicedOn !== null && typeof params.invoicedOn !== "undefined") { __formData.append('invoicedOn', params.invoicedOn as string | Blob);}
   if(params.invoiceNumber !== null && typeof params.invoiceNumber !== "undefined") { __formData.append('invoiceNumber', params.invoiceNumber as string | Blob);}
   if(params.invoiceDueDate !== null && typeof params.invoiceDueDate !== "undefined") { __formData.append('invoiceDueDate', params.invoiceDueDate as string | Blob);}
   if(params.invoiceAmount !== null && typeof params.invoiceAmount !== "undefined") { __formData.append('invoiceAmount', JSON.stringify(params.invoiceAmount));}
   if(params.formFile !== null && typeof params.formFile !== "undefined") { __formData.append('formFile', params.formFile as string | Blob);}
   if(params.fileType !== null && typeof params.fileType !== "undefined") { __formData.append('fileType', JSON.stringify(params.fileType));}
   if(params.aviClientId !== null && typeof params.aviClientId !== "undefined") { __formData.append('aviClientId', params.aviClientId as string | Blob);}
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/fileportal/uploadClientFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OkResult>;
      })
    );
  }
  /**
   * @param params The `FilePortalService.UploadClientFileParams` containing the following parameters:
   *
   * - `year`:
   *
   * - `month`:
   *
   * - `isInvoice`:
   *
   * - `invoicedOn`:
   *
   * - `invoiceNumber`:
   *
   * - `invoiceDueDate`:
   *
   * - `invoiceAmount`:
   *
   * - `formFile`:
   *
   * - `fileType`:
   *
   * - `aviClientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  UploadClientFile(params: FilePortalService.UploadClientFileParams): __Observable<OkResult> {
    return this.UploadClientFileResponse(params).pipe(
      __map(_r => _r.body as OkResult)
    );
  }
}

module FilePortalService {

  /**
   * Parameters for GetAllFileNamesForClientInBlob
   */
  export interface GetAllFileNamesForClientInBlobParams {
    year: number;
    month: number;
    clientId: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for DownloadFileFromBlob
   */
  export interface DownloadFileFromBlobParams {
    fullFilePath?: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for CheckClientFileExists
   */
  export interface CheckClientFileExistsParams {
    year?: number;
    month?: number;
    fileName?: string;
    aviClientId?: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for UploadClientFile
   */
  export interface UploadClientFileParams {
    year?: number;
    month?: number;
    isInvoice?: boolean;
    invoicedOn?: string;
    invoiceNumber?: string;
    invoiceDueDate?: string;
    invoiceAmount?: number;
    formFile?: Blob;
    fileType?: 'Invoice' | 'Backup';
    aviClientId?: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }
}

export { FilePortalService }
